import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from "react-router-dom";
import Login from "./containers/Auth"
import News from './containers/News';
import { isLoggedIn, hasLabelRequestAccess } from './utils';
import Tickets from './containers/Tickets';
import MainContainer from "./containers/Main"
import NewReleases from './containers/Releases';
import NewVideoReleases from './containers/VideoReleases';
import VideoReleasesHistory from './containers/VideoReleases/VideoReleasesHistory';
import ViewVideoReleases from './containers/VideoReleases/ViewVideoReleases';
import ReportsRequests from './containers/Reports';
import UserDetails from './containers/UserDetails.js';
import ViewReleases from './containers/Releases/ViewReleases';
import ViewUserDetails from './containers/UserDetails.js/ViewUserDetails';
import ViewTickets from './containers/Tickets/ViewTickets';
import ApprovedRelease from './containers/Releases/ApprovedRelease';
import RejectedRelease from './containers/Releases/RejectedRelease';
import Payout from './containers/Payout';
import TakendownRelease from './containers/Releases/TakedownRelease';
import UGC from './containers/UgcClaims';
import Linking from './containers/ProfileLinking';
import Pitching from './containers/PlaylistPitching';
import Whitelisting from './containers/WhiteListing/index.js';
import Promotions from './containers/Promotions/index.js';
import Lyrics from './containers/Lyrics/index.js';
import UserActions from './containers/UserActions/index.js';
import LiveAnalytics from './containers/LiveAnalytics';
import Dashboard from './containers/ComingSoon';
import LabelRequests from './containers/LabelRequests';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  return isLoggedIn() ? (
    <MainContainer location={location} match={{ path: location.pathname }}>
      {children}
    </MainContainer>
  ) : (
    <Navigate to="/login" replace />
  );
};

const PublicRoute = ({ children }) => {
  return isLoggedIn() ? <Navigate to="/" replace /> : children;
};

const StandaloneRoute = ({ children }) => {
  return isLoggedIn() ? children : <Navigate to='/login' replace />;
};

const LabelRequestRoute = ({ children }) => {
  const location = useLocation();
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  }
  if (!hasLabelRequestAccess()) {
    return <Navigate to="/" replace />;
  }
  return (
    <MainContainer location={location} match={{ path: location.pathname }}>
      {children}
    </MainContainer>
  );
};

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/news" element={<PrivateRoute><News /></PrivateRoute>} />
        <Route path="/tickets" element={<PrivateRoute><Tickets /></PrivateRoute>} />
        <Route path="/payout" element={<PrivateRoute><Payout /></PrivateRoute>} />
        <Route path="/view_tickets/:id" element={<PrivateRoute><ViewTickets /></PrivateRoute>} />
        <Route path="/user_details" element={<PrivateRoute><UserDetails /></PrivateRoute>} />
        <Route path="/user_actions" element={<PrivateRoute><UserActions /></PrivateRoute>} />
        <Route path="/releases/review" element={<PrivateRoute><NewReleases /></PrivateRoute>} />
        <Route path="/release/approved" element={<PrivateRoute><ApprovedRelease /></PrivateRoute>} />
        <Route path="/release/rejected" element={<PrivateRoute><RejectedRelease /></PrivateRoute>} />
        <Route path="/release/takendown" element={<PrivateRoute><TakendownRelease /></PrivateRoute>} />
        <Route path="/report_requests" element={<PrivateRoute><ReportsRequests /></PrivateRoute>} />
        <Route path="/view_releases/:id" element={<PrivateRoute><ViewReleases /></PrivateRoute>} />
        <Route path="/view_user_details/:id" element={<PrivateRoute><ViewUserDetails /></PrivateRoute>} />
        <Route path="/ugc_claims" element={<PrivateRoute><UGC /></PrivateRoute>} />
        <Route path="/profile_linking" element={<PrivateRoute><Linking /></PrivateRoute>} />
        <Route path="/playlist_pitching" element={<PrivateRoute><Pitching /></PrivateRoute>} />
        <Route path="/whitelisting" element={<PrivateRoute><Whitelisting /></PrivateRoute>} />
        <Route path="/promotions" element={<PrivateRoute><Promotions /></PrivateRoute>} />
        <Route path="/lyrics_distribution" element={<PrivateRoute><Lyrics /></PrivateRoute>} />
        <Route path="/video_releases/review" element={<PrivateRoute><NewVideoReleases /></PrivateRoute>} />
        <Route path="/video_releases/history" element={<PrivateRoute><VideoReleasesHistory /></PrivateRoute>} />
        <Route path="/view_video_release/:id" element={<PrivateRoute><ViewVideoReleases /></PrivateRoute>} />
        <Route path="/live-analytics" element={<StandaloneRoute><LiveAnalytics /></StandaloneRoute>} />
        <Route path="/label-requests" element={<LabelRequestRoute><LabelRequests /></LabelRequestRoute>} />
      </Routes>
    </Router>
  );
}
